import { useEffect, useState, useRef } from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Edit'
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Table, Empty, Modal, Button, message, Space, Tag } from 'antd';
import { getAll, drop } from '../../../../apis/TipoLiquidacionApi';

const { confirm } = Modal;

const routes = [
  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Catálogos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Tipos de Liquidacion</span>
      </>
    ),
  }
];


const TipoLiquidacionPage = () => {
    const [items, setItems] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [objectSelected, setObjectSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    
    const columns = [
      {
        title: 'Tipo Liq.',
        dataIndex: 'tipo',
        key: 'tipo',
      },
      {
        title: 'Descripción',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Acciones',
        dataIndex: 'actions',
        key: 'actions',
        render: (_, record) => (
          <Space>
            <Button 
              type='primary' 
              size='small' 
              onClick={() => openDetails(record)}
            >
              Editar
            </Button>
            <Button 
              type='primary' 
              size='small' 
              danger 
              onClick={() => deleteConfirm(record)}
            >
              Eliminar
            </Button>
          </Space>
        )
      }
    ];

    const openDetails = async (object) => {
      setOpenEdit(true);
      setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas que deseas eliminar este tipo de liquidacion?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar esta información',
            onOk: () => deleteOk(item.id),
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id) => {
        const response = await drop(id);
        if(response.ok){
            message.success('¡El tipo de liquidacion ha sido eliminado!');
            await refreshData();
        }
    }

    const btnClick = () => {
      setOpenEdit(true);
      setObjectSelected(null);
    }

    const onHandlerFinish = async (refresh) => {
      setOpenEdit(false);
      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async () => {
      setLoading(true);
      const response = await getAll();
      if(response.ok){
        setItems(response.payload);
      }
      setLoading(false);
    }

    const effectRan = useRef(false);
    useEffect(() => {
      if (!effectRan.current) {
        (async () => {
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    return (
      <PageApp 
        routes={routes} 
        title={'Tipos de Liquidacion'} 
        extraCard={[
          <Button type="primary" onClick={btnClick}>
            Agregar Tipo de Liquidacion
          </Button>
        ]}
      >
        {
          loading ? (
            <p>Cargando...</p>
          ) : (
            items.length === 0 ? 
              <Empty description="No hay tipos de liquidacion registrados" /> : 
              <Table 
                dataSource={items} 
                columns={columns} 
                rowKey="id"
              />
          )
        }
        {
          openEdit && (
            <ModalEdit 
              title={objectSelected ? "Editar Tipo de Liquidacion" : "Crear Tipo de Liquidacion"} 
              id={objectSelected?.id} 
              open={openEdit} 
              finish={onHandlerFinish}
            />
          )
        }
      </PageApp>
    );
}   

export default TipoLiquidacionPage;